import createIcon from '../../createIcon';

/**
 * @component @name RiceBowl
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTUuNjkgNC40NyAxOC44NiA4IDIwLjI1VjIySDE2VjIwLjI1QzE5LjUzIDE4Ljg2IDIyIDE1LjY5IDIyIDEyWk0yMCAxMkgxNlY1LjA4QzE4LjM5IDYuNDcgMjAgOS4wNSAyMCAxMlpNMTQgNC4yNlYxMkgxMFY0LjI2QzEwLjY0IDQuMSAxMS4zMSA0IDEyIDRDMTIuNjkgNCAxMy4zNiA0LjEgMTQgNC4yNlpNNCAxMkM0IDkuMDUgNS42MSA2LjQ3IDggNS4wOFYxMkg0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RiceBowl = createIcon('RiceBowl', [
  [
    'path',
    {
      d: 'M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 15.69 4.47 18.86 8 20.25V22H16V20.25C19.53 18.86 22 15.69 22 12ZM20 12H16V5.08C18.39 6.47 20 9.05 20 12ZM14 4.26V12H10V4.26C10.64 4.1 11.31 4 12 4C12.69 4 13.36 4.1 14 4.26ZM4 12C4 9.05 5.61 6.47 8 5.08V12H4Z',
      key: '1nn1gv',
    },
  ],
]);

export default RiceBowl;
